module.exports = __webpack_public_path__ + "img/sanbao-shuomingshu.86bff3e8.png";